import { FC, Fragment, useEffect, useState} from "react";

import PaginationNav from "src/components/actionDashboard/paginationNav";
import { CopayClaimsData, CopayTypeProps } from "./types";
import CopayBucketTableHeader from "src/components/actionDashboard/copayBucket/copayBucketTableHeader";
import CopayBucketTableBody from "src/components/actionDashboard/copayBucket/copayBucketTableBody";
import { QueryParamsState } from "src/components/manufacturer/caseListing";


const CopayBucketTable: FC<CopayTypeProps> = ({ tableData, currentPage, onPageChange, refreshListing }) => {

  const [queryParam, setQueryParam] = useState<QueryParamsState>({
      direction: "desc",
      sort_by: "bi_case_id",
    });
  
    const [sortedData, setSortedData] = useState<CopayClaimsData[]>([]);
  
    // Initialize sortedData whenever new data comes from props
    useEffect(() => {
      if (tableData?.copay_claims_data) {
        setSortedData([...tableData.copay_claims_data]);
      }
    }, [tableData]);
  
    const changeIdOrder = (tableHeader: string) => {
      const newParams: QueryParamsState = {
        sort_by: tableHeader,
        direction:
          tableHeader === queryParam.sort_by
            ? queryParam.direction === "desc"
              ? "asc"
              : "desc"
            : "desc",
      };
  
      let sorted = [...(tableData?.copay_claims_data || [])];
  
      switch (newParams.sort_by) {
        case "bi_case_id":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? Number(a.bi_case_id) - Number(b.bi_case_id)
              : Number(b.bi_case_id) - Number(a.bi_case_id)
          );
          break;
  
        case "patient_id":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? Number(a.patient_id) - Number(b.patient_id)
              : Number(b.patient_id) - Number(a.patient_id)
          );
          break;
  
        case "drug_name":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.drug_name || "").localeCompare(b.drug_name || "")
              : (b.drug_name || "").localeCompare(a.drug_name || "")
          );
          break;
  
        case "patient_name":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.patient_name || "").localeCompare(b.patient_name || "")
              : (b.patient_name || "").localeCompare(a.patient_name || "")
          );
          break;
  
        case "bi_completed":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.bi_completed || "").localeCompare(b.bi_completed || "")
              : (b.bi_completed || "").localeCompare(a.bi_completed || "")
          );
          break;
  
        case "bi_submitted":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.bi_submitted || "").localeCompare(b.bi_submitted || "")
              : (b.bi_submitted || "").localeCompare(a.bi_submitted || "")
          );
          break;
  
        case "date_of_service":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.date_of_service || "").localeCompare(b.date_of_service || "")
              : (b.date_of_service || "").localeCompare(a.date_of_service || "")
          );
          break;
  
        case "insurance_name":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.insurance_name || "").localeCompare(b.insurance_name || "")
              : (b.insurance_name || "").localeCompare(a.insurance_name || "")
          );
          break;
  
        case "provider":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.provider || "").localeCompare(b.provider || "")
              : (b.provider || "").localeCompare(a.provider || "")
          );
          break;
  
        case "copay_status":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.copay_status || "").localeCompare(b.copay_status)
              : (b.copay_status).localeCompare(a.copay_status)
          );
          break;
           case "days_until_copay_claim_filed":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? Number(a.days_until_copay_claim_filed) - Number(b.days_until_copay_claim_filed)
              : Number(b.days_until_copay_claim_filed) - Number(a.days_until_copay_claim_filed)
          );
          break;
          case "practice_name":
          sorted.sort((a, b) =>
            newParams.direction === "desc"
              ? (a.practice.name || "").localeCompare(b.practice.name)
              : (b.practice.name).localeCompare(a.practice.name)
          );
          break;
  
        default:
          break;
      }
      
  
      setSortedData(sorted);
      setQueryParam(newParams);
    };
  return (
    <Fragment>
      <div className="table-responsive-sm table-responsive-md table-responsive-lg flex-fill">
        <table className="table table-striped table-sm m-0">
          <CopayBucketTableHeader queryParam={queryParam} changeIdOrder={changeIdOrder}/>
          <CopayBucketTableBody
            data={sortedData}
           refreshListing={refreshListing}
          />
        </table>
      </div>

      {tableData?.page_count > 1 && (
        <PaginationNav currentPage={currentPage} pageCount={tableData.page_count} onPageChange={onPageChange} />
      )}
    </Fragment>
  );
};

export default CopayBucketTable;
